const ORGANIZATION_SIZE_OPTIONS = [
  { label: "Startup", value: "STARTUP" },
  { label: "Midsize Company", value: "MIDSIZE_COMPANY" },
  { label: "Large Company", value: "LARGE_COMPANY" },
];

export default ORGANIZATION_SIZE_OPTIONS;
